/**
 * @param {string} url - The URL to parse.
 * @returns {string}   - The part number.
 * @example
 * getPartNumberFromUrl('https://buy.garmin.com/en-US/US/p/1234') => '1234'
 */
export const getPartNumberFromUrl = (url) => url.split('pn/')[1];
